import { Flex, Box } from "@chakra-ui/react"
import Searchbar from "components/UI/molecules/Searchbar"
import MainLayout from "../MainLayout"
import CustomersTable from "./CustomersTable"
import { useCustomersContext } from "providers/CustomersProvider/CustomersProvider"


const CustomersTemplate = () => {
  const { searchValue, handleSearchChange, handleSearchClick } = useCustomersContext()

  return (
    <MainLayout navigation>
      <Flex flexDirection={"column"} >
        <Flex
          width={"100%"}
          alignItems={"center"}
          justifyContent={"flex-end"}
        >
          <Searchbar
            value={searchValue}
            onChange={handleSearchChange}
            onSearchBtnClick={handleSearchClick}
          />
        </Flex>
        <Box mt={"20px"}>
          <CustomersTable />
        </Box>
      </Flex>
    </MainLayout>
  )
}

export default CustomersTemplate
